import styled from 'styled-components';
import colors from 'Styles/colors';
import { slideIn } from 'Styles/effects';
import { ReactComponent as _Warning } from 'Images/warning-delete.svg';
import Button from 'shared/ui/Button';
import BaseCancelButton from 'shared/ui/CancelButton';

export const ModalContent = styled.div`
  width: min(100%, 560px);
  max-width: calc(100vw - 32px);
  padding: 24px 28px 28px;
  box-shadow: 0 2px 50px 0 rgba(0, 0, 0, 0.24);
  border-radius: 2px;
  border-top: 10px solid ${colors.softBlue};
  background: ${({ theme }) => theme.backgrounds.modal};
  ${slideIn}
`;

export const ModalTitle = styled.div`
  display: flex;
  margin-bottom: 14px;
`;

export const Warning = styled(_Warning)`
  path {
    fill: ${({ theme }) => theme.text.modalTitle2};
  }
  align-self: center;
`;

export const Title = styled.div`
  color: ${({ theme }) => theme.text.modalTitle2};
  font-weight: 600;
  font-size: 21.5px;
  margin-left: 13px;
`;

export const ModalBody = styled.div`
  text-align: left;
`;

export const WarningText = styled.p`
  max-width: 480px;
  margin: 2px 0 20px;
  line-height: 1.45;
  font-size: 12.5px;
  color: ${({ theme }) => theme.text.modalTitle2};
`;

export const EditorWrapper = styled.div`
  margin-top: 6px;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 28px;
`;

export const ConfirmButton = styled(Button)``;

export const CancelButton = styled(BaseCancelButton)`
  margin-right: 10px;
`;
